var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRepo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.469 4.22912C14.176 3.94794 14.176 3.49206 14.469 3.21088C14.7619 2.92971 15.2368 2.92971 15.5297 3.21088L20.7803 8.25088C20.921 8.38591 21 8.56905 21 8.76C21 8.95096 20.921 9.13409 20.7803 9.26912L15.5297 14.3091C15.2368 14.5903 14.7619 14.5903 14.4689 14.3091C14.176 14.0279 14.176 13.572 14.469 13.2909L18.4391 9.48H7.75052C6.88847 9.48 6.06173 9.80871 5.45217 10.3938C4.84261 10.9789 4.50017 11.7725 4.50017 12.6V20.28C4.50017 20.6776 4.16434 21 3.75008 21C3.33582 21 3 20.6776 3 20.28V12.6C3 11.3906 3.5005 10.2308 4.39139 9.37559C5.28229 8.52043 6.49061 8.04 7.75052 8.04H18.4391L14.469 4.22912Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRepo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/repo.ca9b6f16613fc245c4d0772bf343e2a3.svg";